<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="content EC_width">
      <!-- 左边菜单 -->
      <div class="left_aside">
        <el-tree :data="treeDataList"
                 :props="defaultProps"
                 @node-click="handleNodeClick"
                 :expand-on-click-node="true"
                 :default-expanded-keys="expandedkeys"
                 :current-node-key="currentNodekey"
                 node-key="id"
                 ref="tree"></el-tree>
      </div>
      <!-- 右边列表内容 -->
      <div class="rightContent">
        <div class="title">
          <span>
            <!-- Tranning conference -->
            {{ activeMenuName }}
          </span>
        </div>
        <div class="news_bar"
             v-for="(item, index) in newsList"
             :key="index">
          <router-link :to="{ name: 'enInforDetail', query: { urltitle: urltitles, id: item.id, column_Type: item.cid } }">
            <div class="news_bar_text">
              <a>
                {{ item.title }}
              </a>
            </div>
            <div class="news_bar_tip">
              <i class="el-icon-date "
                 style="margin-right: 10px; color: #B1B1B1;"></i>
              <span>{{ formatter(item.publishtime, 'en') }}</span>
              <i class=" el-icon-view "
                 style="margin-left: 40px;margin-right: 10px; color: #B1B1B1;"></i> <span>Views:{{ item.clickVolume }}</span>
            </div>
          </router-link>
        </div>
        <!-- 分页器 -->
        <!-- <pagination></pagination> -->
        <div class="pagination_Wrap"
             v-if="pageCount > 0">
          <pagination :en="true"
                      :total="pageCount"
                      :limit="pageSize"
                      :page="pageIndex"
                      @page-change="pageChange"></pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbPage from '../home/breadcrumbPage';
export default {
  name: 'enInforList',
  components: {
    breadcrumbPage
  },
  data () {
    return {
      activeMenuName: '',
      activeMenu: 0,
      apiData: [],
      menuActiveItem: 0,
      treeDataList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentNodekey: '', //默认选中的节点树
      selcid: 0,
      pageCount: 0,
      pageIndex: 1,
      pageSize: 9,
      newsList: [],
      urltitles: 'news',
      expandedkeys: [],
      showid: 0
    };
  },
  created () {
    if (this.$route.query.urltitle != undefined) {
      this.urltitles = this.$route.query.urltitle.replace(/\s+/g, '').toLowerCase();
    }
    if (this.$route.query.showid != undefined) {
      this.showid = this.$route.query.showid;
    }
    // this.getData();
    this.GetColumsInfoAllList();
  },
  methods: {
    getData () {
      var that = this;
      fetch('/data.json')
        .then(res => {
          return res.json();
        })
        .then(data => {
          that.apiData = data.enInforList.data;
        })

    },
    tagMenu (index) {
      this.activeMenu = index;
    },
    activeMenuclick (index) {
      this.menuActiveItem = index;
    },
    handleNodeClick (data) {
      if (data.children == undefined) {
        this.activeMenuName = data.name;
        this.selcid = data.id;
        this.pageIndex = 0;
        this.pageCount = 0;
        this.GetNewsList();
      }
    },
    //获取栏目数据
    GetColumsInfoAllList () {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetColumsInfoAllList', {
          cType: 1,
          isCHorEN: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.treeDataList = _this.toTree(res.data.data);
            var dataobj = this.treeDataList.filter(function (el) {
              return el.name.replace(/\s+/g, '').toLowerCase() == _this.urltitles;
            });
            switch (_this.urltitles) {
              case 'trainingconference':
                _this.expandedkeys = [dataobj[0].id, dataobj[0].children[0].id];
                _this.currentNodekey = dataobj[0].children[0].id;
                _this.activeMenuName = dataobj[0].children[0].name;
                break;
              case 'journal':
                _this.expandedkeys = [dataobj[0].id, dataobj[0].children[Number(this.showid)].id];
                _this.currentNodekey = dataobj[0].children[Number(this.showid)].id;
                _this.activeMenuName = dataobj[0].children[Number(this.showid)].name;
                break;
              default:
                _this.currentNodekey = dataobj[0].id;
                _this.activeMenuName = dataobj[0].name;
                break;
            }
            _this.selcid = this.currentNodekey;
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(_this.currentNodekey);
            }); //一定要加这个选中了否则样式没有出来})
            _this.GetNewsList();
          }
        });
    },
    //获取新闻列表
    GetNewsList () {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetGpSiteNewInfoPageList', {
          keyword: '',
          id: -1,
          parentID: 0,
          column_Type: _this.selcid,
          pageIndex: _this.pageIndex,
          pageSize: _this.pageSize
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.newsList = [];
            _this.newCount = 0;
            let data = res.data.data;
            if (data.gpSiteNewInfoViewsViews != null && data.gpSiteNewInfoViewsViews.length > 0) {
              _this.newsList = data.gpSiteNewInfoViewsViews;
              _this.pageCount = data.pageCount;
            }
          }
        });
    },
    toTree (data) {
      let treeData = [];
      if (!Array.isArray(data)) return treeData;

      data.forEach(item => {
        delete item.children; //删除item下的children，以防多次调用
      });

      let map = {};
      data.forEach(item => {
        map[item.id] = item;
      });

      data.forEach(item => {
        let parent = map[item.parentid]; //判断item的pid是否是否存在map中
        if (parent) {
          //如果存在则表示item不是最顶层的数据
          (parent.children || (parent.children = [])).push(item);
        } else {
          treeData.push(item); // 如果不存在 则是顶层数据
        }
      });
      return treeData;
    },
    /**点击分页事件 */
    pageChange (page) {
      if (document.body.scrollTop) {
        document.body.scrollTop = 0;
      } else {
        document.documentElement.scrollTop = 0;
      }
      if (page == this.pageIndex) {
        return;
      }
      this.newsList = [];
      this.pageIndex = page;
      this.GetNewsList();
    }
  },
  watch: {
    $route () {
      if (this.$route.query.urltitle != undefined) {
        this.urltitles = this.$route.query.urltitle.replace(/\s+/g, '').toLowerCase();
      }
      this.GetColumsInfoAllList();
    }
  }
};
</script>

<style scoped>
.content {
    padding-top: 30px;
    display: flex;
    flex: 1;
}
/* 左边菜单栏 */
.left_aside {
    width: 340px;
    box-sizing: border-box;
    padding-right: 30px;
}
.switch_menu {
    height: 45px;
    font-size: 14px;
    font-weight: bold;
    line-height: 45px;
    display: inline-block;
    width: 100%;
    cursor: pointer;
    box-sizing: border-box;
    padding-left: 10px;
}
.menu_Wrap {
    list-style: none;
    padding: 0;
    margin: 0;
    display: none;
}
.menu_Wrap li {
    padding: 10px;
}
.menu_Wrap li a {
    font-size: 12px;
    color: #333;
}
.menu_Wrap .leftMenuActive a {
    color: #5f9ea0;
    text-decoration: underline;
}
/* 右边内容 */
.rightContent {
    flex: 1;
}
.title {
    height: 50px;
    line-height: 50px;
    color: #0b8686;
    font-size: 20px;
}
.title span {
    line-height: 20px;
    padding-left: 10px;
    border-left: 2px solid #0b8686;
    display: inline-block;
}
.news_bar {
    border-top: 1px solid #ddd;
    padding-top: 20px;
}
.news_bar_text a {
    font-size: 18px;
    font-family: Arial;
    font-weight: 400;
    color: #000000;
    line-height: 22px;
}
.news_bar_text a:hover {
    color: #5f9ea0;
    text-decoration: underline;
}
.news_bar_tip {
    margin-bottom: 20px;
    margin-top: 12px;
}
.news_bar_tip span {
    font-size: 16px;
    font-family: Arial;
    font-weight: 400;
    color: #b1b1b1;
    line-height: 30px;
}
.DropMenuActive {
    display: block;
}
.menuActive {
    color: #0b8586 !important;
}
.activeMenuTop {
    background: #0b8586;
    color: #fff;
}
</style>
<style lang="scss" scoped>
::v-deep .el-tree-node__label {
    font-size: 18px;
    font-family: Arial;
    font-weight: bold;
    color: #000000;
}

::v-deep .el-tree-node__content {
    height: 46px;
    width: 280px;
}
::v-deep .el-tree-node.is-current > .el-tree-node__content {
    background-color: #0b8586 !important;
    color: #fff !important;
}
::v-deep .el-tree-node.is-current > .el-tree-node__content > .el-tree-node__label {
    color: #fff;
}

::v-deep .el-tree-node__expand-icon {
    color: #000;
}
// ::v-deep .expanded.el-tree-node__expand-icon.el-icon-caret-right {
//     color: #fff;
// }
</style>
